import { getResource } from "selectors/resources";

/**
 * @param {Object} state
 * @param {String} responseId
 * @returns {String}
 */
export function getResponseEditorActiveLanguage(state, responseId) {
  /** @type Client */
  const client = getResource(state, "client");

  if (!client) {
    throw new Error("\"client\" resource not loaded");
  }

  return (
    state.responsesPage.getIn(["responseEditorActiveLanguages", responseId]) ||
    client.language
  );
}
